import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { Cliente } from 'src/app/Models/cliente/cliente';
import { RangoFechas } from 'src/app/Models/rangofechas/rango-fechas';
import { Usuario } from 'src/app/Models/usuario/usuario';
import { AuthService } from 'src/app/Service/auth.service';
import { DataService } from 'src/app/Service/data.service';
import { InfoComponent } from '../../objects/info/info/info.component';
import { LoadingComponent } from '../../objects/loading/loading.component';
import { NothingComponent } from '../../objects/nothing/nothing.component';
import { VentasComponent } from '../ventas/ventas.component';
import { AlertComponent } from '../../objects/alert/alert/alert.component';
import { Proveedor } from 'src/app/Models/proveedor/proveedor';
import { AlertType } from 'src/app/Models/alert/alert-type';
import { DetalleCompra } from 'src/app/Models/compra/detallecompra/detalle-compra';
import { Compra } from 'src/app/Models/compra/compra/compra';
import { DatePipe } from '@angular/common';
import { ReportViewerService } from 'src/app/Service/report-viewer.service';

@Component({
  selector: 'app-comprasinf',
  templateUrl: './comprasinf.component.html',
  styleUrls: ['./comprasinf.component.css'],
  providers: [DatePipe]
})
export class ComprasinfComponent implements OnInit {

  @ViewChild('btnclose', null) btnclose: ElementRef;
  @ViewChild('btnshow', null) btnshow: ElementRef;
  @ViewChild(AlertComponent, null) alert: AlertComponent;
  @ViewChild(LoadingComponent, null) loading: LoadingComponent;
  @ViewChild(NothingComponent, null) public nothing: NothingComponent;
  @ViewChild(InfoComponent, null) info: InfoComponent;
  @ViewChild(VentasComponent, null) impventas: VentasComponent;
  public usuario: Usuario = new Usuario();
  public rangofechas: RangoFechas = new RangoFechas();
  public tipoinforme = 0;
  public funcion: Function = null;
  public isShow: boolean = false;
  public pagina: number = 0;
  public modal = "modal-lg";
  public zindex: number = 10000;
  public compras: Compra[] = [];
  public detcompras: DetalleCompra[] = [];
  public totalventas: number = 0;
  public totalefectivo: number = 0;
  public totaltarjetas: number = 0;
  public sumacantidad: number = 0;
  public sumatotal: number = 0;
  public empresa: any;
  public pagventas: any = 0;
  public isenabled: boolean = true
  public proveedor: Proveedor = new Proveedor();
  public listproveedores: Proveedor[] = [];
  public alertType: AlertType = new AlertType();

  public today = new Date();
  public fechaHoraActual: Date = new Date()
  constructor(private data: DataService, private datePipe: DatePipe, private route: Router, private reportViewer: ReportViewerService) { }


  ngOnInit() {
    this.getProveedor();
    this.getEmpresa()
  }

  public show(affterfunction: Function = null) {
    this.funcion = affterfunction;
    this.isShow = true;
    this.setInitialDates();
    this.showTab(1);
    setTimeout(() => {
      this.btnshow.nativeElement.click();
      this.info.hide();
    }, 10);
  }

  getEmpresa() {
    this.data.GetSimple(this.data.api.empresa).subscribe(r => {
      //console.log("Empresa:", r);
      this.empresa = r[0];
    }), (error) => {
      console.log(error);

    };
  }

  showTab(i) {
    this.pagina = i;
    if (this.pagina == 1) { this.modal = 'modal-lg'; }
    else { this.modal = ''; }
  }

  async Compras() {

    await this.GetData();
    // Llama a GetTotalCompras solo después de que GetData se haya completado
    await this.GetTotalCompras();
  }

  async ComprasDetallado() {

    await this.GetDataDet();
    // Llama a GetTotalComprasDet solo después de que GetData se haya completado
    await this.GetTotalComprasDet();
  }

  async GetData1() {
    await this.data.PrintP(this.data.api.compra, this.rangofechas).then(r => {
      console.log(r);
      if (r.length < 1) {
        console.error("Error");
      } else {
        this.compras = r;
      }
    }).catch(e => { console.log(e) });
  }

  async GetDataDet1() {
    await this.data.PrintP(this.data.api.detcompra, this.rangofechas).then(r => {
      console.log(r);
      if (r.length < 1) {
        console.error("Error");
      } else {
        this.detcompras = r;
      }
    }).catch(e => { console.log(e) });
  }

  GetTotalCompras() {
    this.totalventas = 0;
    //this.totalefectivo = 0;
    this.totaltarjetas = 0;

    this.compras.forEach(compra => {
      this.totalventas += +compra.total
      //this.totalefectivo+= +compra.efectivo
      this.totaltarjetas += +compra.tarjetachq
    });
  }

  GetTotalComprasDet() {
    this.sumacantidad = 0;
    this.sumatotal = 0;

    this.detcompras.forEach(detalle => {
      this.sumacantidad += +detalle.cantidad
      this.sumatotal += +detalle.subtotal1
    });

  }

  openNewTab() {
    const relativeUrl = this.route.createUrlTree(['printer/informecompras']).toString();
    const baseUrl = window.location.origin;
    const fullUrl = `${baseUrl}/${relativeUrl}`;
    console.log(fullUrl);
    window.open(fullUrl, '_blank');
  }

  setInitialDates() {
    const today = new Date();
    this.rangofechas.fecfin = this.formatearFechas(today);

    // Obtener el primer día del mes
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    this.rangofechas.fecini = this.formatearFechas(firstDayOfMonth);
  }

  formatearFechas(fecha) {
    const parsedDate = moment(fecha, 'DD-MM-YYYY');
    fecha = parsedDate.format('YYYY-MM-DD');
    return fecha;
  }

  formatFecha(fecha: Date | string, format: string): string {
    // Formatear la fecha a 'dd-MM-yyyy'
    return this.datePipe.transform(fecha, format) || '';
  }

  setRango() {
    let fechainicio = this.formatearFechas(this.rangofechas.fecini);
    let fechafin = this.formatearFechas(this.rangofechas.fecfin);
    this.rangofechas.fecini = fechainicio;
    this.rangofechas.fecfin = fechafin;
  }

  async imprimirVenta1() {
    console.log(this.rangofechas);
    const myobj = JSON.stringify(this.rangofechas);
    console.log(myobj);
    if (this.tipoinforme == 1) {
      //this.data.setFechas(this.rangofechas)
      // this.route.navigate(['printer/infcomprasproductos']);
      await this.ComprasDetallado()
      setTimeout(() => {
        const blob = this.printerComprasDetallado();
        if (blob) {
          const fecha = this.formatFecha(new Date(), 'yyyy-MM-dd');
          this.reportViewer.mostrarPDF(
            blob,
            'Reporte de Compras Detallado',
            `compras_detallado_${fecha}.pdf`
          );
          this.close()
        }

      }, 500);
    } else if (this.tipoinforme == 0) {

      //this.data.setFechas(this.rangofechas)
      // this.route.navigate(['printer/informecompras']);
      await this.Compras()
      setTimeout(() => {
        const blob = this.printerCompras();
        if (blob) {
          const fecha = this.formatFecha(new Date(), 'yyyy-MM-dd');
          this.reportViewer.mostrarPDF(
            blob,
            'Reporte de Compras',
            `compras_${fecha}.pdf`
          );
        }
      }, 500);

    }
  }

  async getProveedor() {
    console.log("obteniendo proveedores");
    await this.data.AsyncGetSimple(this.data.api.proveedor).then(r => {
      this.listproveedores = r;
    })

  }

  printerCompras1(): Blob | null {
    const doc = new jsPDF();
    const titulo = { text: 'INFORME DE COMPRAS', x: 80, y: 20 };


    // Función para agregar encabezado en cada página
    const addHeader = () => {
      doc.setFontSize(14);
      doc.text(titulo.text, titulo.x, titulo.y);
      const textWidth = doc.getTextWidth(titulo.text);  // Obtener el ancho del texto
      const lineY = titulo.y + 1;  // Posición Y de la línea (1 unidad por debajo del texto)

      doc.setLineWidth(0.5);  // Establecer el grosor de la línea
      doc.line(titulo.x, lineY, titulo.x + textWidth, lineY);
      doc.setFontSize(11);
      doc.text(`Del periodo ${this.formatFecha(this.rangofechas.fecini, 'dd-MM-yyyy')} al periodo ${this.formatFecha(this.rangofechas.fecfin, 'dd-MM-yyyy')}`, 10, 28);
      doc.text(`Generado el dia ${this.formatFecha(this.today, 'dd-MM-yyyy hh:mm')}`, 140, 28);
      //doc.addImage(this.empresa.logo, 'PNG', 10, 8, 20, 9);  // Añade tu imagen
      doc.setFontSize(12);
    };

    // Columnas de la tabla

    const tableColumn = ['Fecha', 'Doc', 'Serie', 'N°', 'Estado', 'Mon', 'Total', 'Tarjeta', 'Efectivo'];
    const tableRows: any[] = [];

    // Obtener filas de una tabla HTML (ejemplo)
    const rows = document.querySelectorAll('#compras tbody tr');
    rows.forEach(row => {
      const cols = row.querySelectorAll('td');
      const data: any[] = [];
      cols.forEach(col => data.push(col.innerText));
      tableRows.push(data);
    });

    // Usar autoTable para generar la tabla
    (doc as any).autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 35,
      margin: { horizontal: 10, vertical: 30 },
      theme: 'grid',
      columnStyles: {
        6: { halign: 'right' },
        7: { halign: 'right' },
        8: { halign: 'right' }
        // Alinear la columna "Cantidad" (índice 3) a la derecha
      },
      styles: {
        fontSize: 10,  // Controla el tamaño de fuente para todo el contenido de la tabla
        cellPadding: 2,  // Espaciado interno de las celdas
      },
      didDrawPage: (data: any) => {
        // Encabezado en cada página

        const pageNumber = data.pageNumber;  // Obtener el número de página
        //const pageCount = doc.getNumberOfPages();

        console.log(data.totalPages);

        addHeader();
        const pagetext = `Página ${pageNumber} `;
        doc.text(pagetext, 170, 15);  // Añade tu imagen
      },
      didDrawHeader: (data: any) => {
        doc.setFontSize(12);
        doc.text('Fecha', data.settings.margin.left, data.cursor.y);
        doc.text('Doc', data.settings.margin.left, data.cursor.y);
        doc.text('Serie', data.settings.margin.left, data.cursor.y);
        doc.text('Numero', data.settings.margin.left, data.cursor.y);
        doc.text('Razon Social', data.settings.margin.left + 40, data.cursor.y);
        doc.text('Estado', data.settings.margin.left + 90, data.cursor.y);
        doc.text('Moneda', data.settings.margin.left + 90, data.cursor.y);
        doc.text('Total', data.settings.margin.left + 140, data.cursor.y);
        doc.text('Tarjetas', data.settings.margin.left + 190, data.cursor.y);
        doc.text('Efectivo', data.settings.margin.left + 240, data.cursor.y);
      }
    });

    // Guardar el archivo PDF
    return doc.output('blob');
    //doc.save('informe.pdf');

  }

  printerComprasDetallado1(): Blob | null {
    const doc = new jsPDF('landscape');
    const titulo = { text: 'INFORME DE COMPRAS DETALLADO', x: 100, y: 20 };


    // Función para agregar encabezado en cada página
    const addHeader = () => {
      doc.setFontSize(14);
      doc.text(titulo.text, titulo.x, titulo.y);
      const textWidth = doc.getTextWidth(titulo.text);  // Obtener el ancho del texto
      const lineY = titulo.y + 1;  // Posición Y de la línea (1 unidad por debajo del texto)

      doc.setLineWidth(0.5);  // Establecer el grosor de la línea
      doc.line(titulo.x, lineY, titulo.x + textWidth, lineY);
      doc.setFontSize(11);
      doc.text(`Del periodo ${this.formatFecha(this.rangofechas.fecini, 'dd-MM-yyyy')} al periodo ${this.formatFecha(this.rangofechas.fecfin, 'dd-MM-yyyy')}`, 10, 28);
      doc.text(`Generado el dia ${this.formatFecha(this.today, 'dd-MM-yyyy hh:mm')}`, 225, 28);
      //doc.addImage(this.empresa.logo, 'PNG', 10, 8, 20, 9);  // Añade tu imagen
      doc.setFontSize(12);
    };

    // Columnas de la tabla

    const tableColumn = ['Fecha', 'Doc', 'Serie', 'Numero', 'Estado', 'Producto', 'Unidad', 'Cantidad', 'Precio', 'Moneda', 'Total'];
    const tableRows: any[] = [];

    // Obtener filas de una tabla HTML (ejemplo)
    const rows = document.querySelectorAll('#comprasdetallado tbody tr');
    rows.forEach(row => {
      const cols = row.querySelectorAll('td');
      const data: any[] = [];
      cols.forEach(col => data.push(col.innerText));
      tableRows.push(data);
    });

    // Usar autoTable para generar la tabla
    (doc as any).autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 35,
      margin: { horizontal: 10, vertical: 30 },
      theme: 'grid',
      columnStyles: {
        7: { halign: 'right' },
        8: { halign: 'right' },
        10: { halign: 'right' }
        // Alinear la columna "Cantidad" (índice 3) a la derecha
      },
      styles: {
        fontSize: 10,  // Controla el tamaño de fuente para todo el contenido de la tabla
        cellPadding: 2,  // Espaciado interno de las celdas
      },
      didDrawPage: (data: any) => {
        // Encabezado en cada página

        const pageNumber = data.pageNumber;  // Obtener el número de página
        //const pageCount = doc.getNumberOfPages();

        console.log(data.totalPages);

        addHeader();
        const pagetext = `Página ${pageNumber} `;
        doc.text(pagetext, 260, 15);  // Añade tu imagen
      },
      didDrawHeader: (data: any) => {
        doc.setFontSize(12);
        doc.text('Fecha', data.settings.margin.left, data.cursor.y);
        doc.text('Tipo', data.settings.margin.left, data.cursor.y);
        doc.text('Serie', data.settings.margin.left, data.cursor.y);
        doc.text('Numero', data.settings.margin.left, data.cursor.y);
        doc.text('Estado', data.settings.margin.left + 40, data.cursor.y);
        doc.text('Producto', data.settings.margin.left + 90, data.cursor.y);
        doc.text('Unidad', data.settings.margin.left + 90, data.cursor.y);
        doc.text('Cantidad', data.settings.margin.left + 140, data.cursor.y);
        doc.text('Precio', data.settings.margin.left + 190, data.cursor.y);
        doc.text('Moneda', data.settings.margin.left + 240, data.cursor.y);
        doc.text('Total', data.settings.margin.left + 290, data.cursor.y);

      }
    });

    // Guardar el archivo PDF
    return doc.output('blob');
    //doc.save('informe.pdf');

  }



  async imprimirVenta() {
    if (this.tipoinforme == 1) {
      await this.ComprasDetallado();

      if (!this.detcompras || this.detcompras.length === 0) {
        this.data.notify(
          'No hay datos en el rango de fechas seleccionado.',
          'Sin resultados',
          this.alertType.warning
        );
        return;
      }

      const blob = this.printerComprasDetallado();
      if (blob) {
        const fecha = this.formatFecha(new Date(), 'yyyy-MM-dd');
        this.reportViewer.mostrarPDF(blob, 'Reporte de Compras Detallado', `compras_detallado_${fecha}.pdf`);
        this.close();
      }

    } else if (this.tipoinforme == 0) {
      await this.Compras();

      if (!this.compras || this.compras.length === 0) {
        this.data.notify(
          'No hay datos en el rango de fechas seleccionado.',
          'Sin resultados',
          this.alertType.warning
        );
        return;
      }

      const blob = this.printerCompras();
      if (blob) {
        const fecha = this.formatFecha(new Date(), 'yyyy-MM-dd');
        this.reportViewer.mostrarPDF(blob, 'Reporte de Compras', `compras_${fecha}.pdf`);
      }
    }
  }

  // También actualizar GetData y GetDataDet para limpiar arrays cuando no hay datos
  async GetData() {
    this.compras = []; // ← limpiar antes de cada consulta
    await this.data.PrintP(this.data.api.compra, this.rangofechas).then(r => {
      console.log(r);
      this.compras = r || [];
    }).catch(e => { console.log(e); });
  }

  async GetDataDet() {
    this.detcompras = []; // ← limpiar antes de cada consulta
    await this.data.PrintP(this.data.api.detcompra, this.rangofechas).then(r => {
      console.log(r);
      this.detcompras = r || [];
    }).catch(e => { console.log(e); });
  }

  printerCompras(): Blob | null {
    const doc = new jsPDF();
    const titulo = { text: 'INFORME DE COMPRAS', x: 80, y: 20 };

    const addHeader = () => {
      doc.setFontSize(14);
      doc.text(titulo.text, titulo.x, titulo.y);
      const textWidth = doc.getTextWidth(titulo.text);
      doc.setLineWidth(0.5);
      doc.line(titulo.x, titulo.y + 1, titulo.x + textWidth, titulo.y + 1);
      doc.setFontSize(11);
      doc.text(
        `Del periodo ${this.formatFecha(this.rangofechas.fecini, 'dd-MM-yyyy')} al periodo ${this.formatFecha(this.rangofechas.fecfin, 'dd-MM-yyyy')}`,
        10, 28
      );
      doc.text(`Generado el dia ${this.formatFecha(this.today, 'dd-MM-yyyy hh:mm')}`, 140, 28);
    };

    const tableColumn = ['Fecha', 'Doc', 'Serie', 'N°', 'Estado', 'Mon', 'Total', 'Tarjeta', 'Efectivo'];

    const tableRows = this.compras.map(item => [
      item.fectra || '',
      item.documento || '',
      item.serie || '',
      item.numero || '',
      item.estado || '',
      item.moneda || '',
      Number(item.total || 0).toFixed(2),
      Number(item.tarjetachq || 0).toFixed(2),
      Number(item['efectivo'] || 0).toFixed(2),
    ]);

    // Fila de totales
    tableRows.push([
      'TOTAL', '', '', '', '', '',
      this.totalventas.toFixed(2),
      this.totaltarjetas.toFixed(2),
      this.totalefectivo.toFixed(2),
    ]);

    (doc as any).autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 35,
      margin: { top: 35, left: 10, right: 10 },
      theme: 'grid',
      columnStyles: {
        6: { halign: 'right' },
        7: { halign: 'right' },
        8: { halign: 'right' },
      },
      styles: { fontSize: 10, cellPadding: 2 },
      didParseCell: (data: any) => {
        // Fila de totales en negrita
        if (data.section === 'body' && data.row.index === tableRows.length - 1) {
          data.cell.styles.fontStyle = 'bold';
        }
      },
      didDrawPage: (data: any) => {
        addHeader();
        doc.text(`Página ${data.pageNumber}`, 170, 15);
      }
    });

    return doc.output('blob');
  }

  printerComprasDetallado(): Blob | null {
    const doc = new jsPDF('landscape');
    const titulo = { text: 'INFORME DE COMPRAS DETALLADO', x: 100, y: 20 };

    const addHeader = () => {
      doc.setFontSize(14);
      doc.text(titulo.text, titulo.x, titulo.y);
      const textWidth = doc.getTextWidth(titulo.text);
      doc.setLineWidth(0.5);
      doc.line(titulo.x, titulo.y + 1, titulo.x + textWidth, titulo.y + 1);
      doc.setFontSize(11);
      doc.text(
        `Del periodo ${this.formatFecha(this.rangofechas.fecini, 'dd-MM-yyyy')} al periodo ${this.formatFecha(this.rangofechas.fecfin, 'dd-MM-yyyy')}`,
        10, 28
      );
      doc.text(`Generado el dia ${this.formatFecha(this.today, 'dd-MM-yyyy hh:mm')}`, 225, 28);
    };

    const tableColumn = ['Fecha', 'Doc', 'Serie', 'Numero', 'Estado', 'Producto', 'Unidad', 'Cantidad', 'Precio', 'Moneda', 'Total'];

    // ← Desde el array, no del DOM
    const tableRows = this.detcompras.map(item => [
      item['idcompra'].fectra || item['idcompra'].fecemi || '',
      item['idcompra'].documento || '',
      item['idcompra'].serie || '',
      item['idcompra'].numero || '',
      item['idcompra'].estado || '',
      item['idproduct'].nombre || '',
      item['idproduct']['unidad'].unidad || '',
      Number(item.cantidad || 0).toFixed(3),
      Number(item.precio || 0).toFixed(2),
      item['idcompra'].moneda || '',
      Number(item.subtotal1 || 0).toFixed(2),
    ]);

    // Fila de totales
    tableRows.push([
      'TOTAL', '', '', '', '', '', '',
      this.sumacantidad.toFixed(3),
      '',
      '',
      this.sumatotal.toFixed(2),
    ]);

    (doc as any).autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 35,
      margin: { top: 35, left: 10, right: 10 },
      theme: 'grid',
      columnStyles: {
        7: { halign: 'right' },
        8: { halign: 'right' },
        10: { halign: 'right' },
      },
      styles: { fontSize: 10, cellPadding: 2 },
      didParseCell: (data: any) => {
        // Fila de totales en negrita
        if (data.section === 'body' && data.row.index === tableRows.length - 1) {
          data.cell.styles.fontStyle = 'bold';
        }
      },
      didDrawPage: (data: any) => {
        addHeader();
        doc.text(`Página ${data.pageNumber}`, 260, 15);
      }
    });

    return doc.output('blob');
  }

  close() {
    this.btnclose.nativeElement.click();
  }

  validate() {
    if (this.rangofechas.fecfin != undefined && this.rangofechas.fecini != undefined) {
      this.isenabled = false;
    }
  }

  GenerarExcel() {
    this.data.GenerateExcel(this.data.api.factura, this.rangofechas).subscribe(r => {
      console.log(r);

      if (r.download_url) {
        window.open(this.data.api.apiBaseUrl + 'api/download_excel' + r.download_url, '_blank');
        setTimeout(() => {
          this.data.DeleteExcel(r.download_url).subscribe(r => console.log(r));
        }, 20000);
      }
    }, (error) => {
      this.data.notify("Error al generar excel", "Error", this.alertType.error);
    });
  }
}
